<template>
    <div>
        <!-- Start Border -->
        <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
            Border
        </div>
        <div class="flex flex-wrap items-center">
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-up" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="data"
                                v-model="element.settings.boxModel.border.top"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-right" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="data"
                                v-model="element.settings.boxModel.border.right"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-down" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="data"
                                v-model="element.settings.boxModel.border.bottom"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-left" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="data"
                                v-model="element.settings.boxModel.border.left"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Type
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.type.options" v-model="element.settings.boxModel.border.type" />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Colour
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-colour class="reset" :classes="{ input: { 'input--composer': true } }"  v-model="element.settings.boxModel.border.color" />
            </div>
        </div>
        <!-- End Border -->

        <!-- Start Border Radius -->
        <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
            Border Radius
        </div>
        <div class="flex flex-wrap items-center">
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-up" />
                            <app-icon icon="arrow-left" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="radius"
                                v-model="element.settings.boxModel.borderRadius.topLeft"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-up" />
                            <app-icon icon="arrow-right" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="radius"
                                v-model="element.settings.boxModel.borderRadius.topRight"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-down" />
                            <app-icon icon="arrow-left" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="radius"
                                v-model="element.settings.boxModel.borderRadius.bottomLeft"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2">
                <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="flex items-center">
                        <div class="w-auto pr-1">
                            <app-icon icon="arrow-down" />
                            <app-icon icon="arrow-right" />
                        </div>
                        <div class="flex-grow w-auto">
                            <app-field-slider
                                class="reset"
                                :data="radius"
                                v-model="element.settings.boxModel.borderRadius.bottomRight"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Border Radius -->
    </div>
</template>

<script>
    import FieldSlider from '@/components/fields/inputs/Slider';
    import FieldSelect from '@/components/fields/inputs/Select';
    import FieldColour from '@/components/fields/inputs/Colour';

    export default {
        components: {
            'app-field-slider': FieldSlider,
            'app-field-select': FieldSelect,
            'app-field-colour': FieldColour
        },
        props: {
            element: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            data:  [
                0, 1, 2, 4, 8
            ],
            radius: [
                0, 2, 4, 8, 100
            ],
            fields: {
                colour: {
                    name: 'Colour',
                    attribute: 'borderColour',
                    placeholder: 'transparent'
                },
                type: {
                    name: 'Type',
                    attribute: 'borderType',
                    options: [
                        {
                            value: 'dotted',
                            label: 'Dotted'
                        },
                        {
                            value: 'dashed',
                            label: 'Dashed'
                        },
                        {
                            value: 'solid',
                            label: 'Solid'
                        },
                        {
                            value: 'none',
                            label: 'None'
                        }
                    ]
                },
                border: {
                    top: {
                        attribute: 'borderTop'
                    },
                    right: {
                        attribute: 'borderRight'
                    },
                    bottom: {
                        attribute: 'borderBottom'
                    },
                    left: {
                        attribute: 'borderLeft'
                    }
                },
                borderRadius: {
                    topLeft: {
                        attribute: 'borderRadiusTopLeft'
                    },
                    topRight: {
                        attribute: 'borderRadiusTopRight'
                    },
                    bottomLeft: {
                        attribute: 'borderRadiusBottomLeft'
                    },
                    bottomRight: {
                        attribute: 'borderRadiusBottomRight'
                    }
                }
            }
        }),
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Forms/Partials/Border.vue